interface HelpSectionProps {
  onNavigateToTab: (tab: 'custom' | 'pipeline') => void;
}

export function HelpSection({ onNavigateToTab }: HelpSectionProps) {
  return (
    <div className="bg-blue-50 dark:bg-blue-900 dark:bg-opacity-30 border border-blue-200 dark:border-blue-700 rounded-lg p-6">
      <h3 className="text-base font-semibold text-blue-900 dark:text-blue-200 mb-4">
        💡 Quick Start Guide
      </h3>
      <ol className="text-sm text-blue-800 dark:text-blue-300 space-y-3">
        <li className="flex gap-3">
          <span className="font-semibold flex-shrink-0 w-6">1.</span>
          <span>
            Check <span className="font-medium">Authentication Status</span> above — ensure your tokens are valid
          </span>
        </li>
        <li className="flex gap-3">
          <span className="font-semibold flex-shrink-0 w-6">2.</span>
          <span>
            Click{' '}
            <button
              onClick={() => onNavigateToTab('custom')}
              className="font-medium text-blue-600 dark:text-blue-400 hover:underline"
            >
              Custom Predict
            </button>
            {' '}to test individual predictions with JSON data
          </span>
        </li>
        <li className="flex gap-3">
          <span className="font-semibold flex-shrink-0 w-6">3.</span>
          <span>
            Or use{' '}
            <button
              onClick={() => onNavigateToTab('pipeline')}
              className="font-medium text-blue-600 dark:text-blue-400 hover:underline"
            >
              Pipeline Test
            </button>
            {' '}for full end-to-end classification workflows
          </span>
        </li>
        <li className="flex gap-3">
          <span className="font-semibold flex-shrink-0 w-6">4.</span>
          <span>
            Enable <span className="font-medium">Recording Session</span> (top) to track all requests and results
          </span>
        </li>
        <li className="flex gap-3">
          <span className="font-semibold flex-shrink-0 w-6">5.</span>
          <span>
            Check the <span className="font-medium">Polling Status</span> panel to monitor request results in real-time
          </span>
        </li>
      </ol>
    </div>
  );
}
